import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardAppSharedService,
  DashboardService,
  Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto,
} from '../../services/wealthlane-award-services';
import { ParticipantVestingScheduleService } from '../../services/wealthlane-award-services/services/ParticipantVestingScheduleService';

const useGetParticipantDashboardVestingSchedule = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_MyHoldings_ParticipantDashboardVestingScheduleDto | undefined,
  unknown
> => {
  const participantDashboardVestingSchedule = useQuery(
    ['getParticipantDashboardVestingSchedule'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        ParticipantVestingScheduleService.getApiAwardApiAppDashboardVestingSchedule()
      );
    }
    // }
  );
  return participantDashboardVestingSchedule;
};

export default useGetParticipantDashboardVestingSchedule;
